import type { Property, PropertyDto } from "@/elements/property/property";
import { mapPropertyThemeFromDto } from "@/elements/property/theme/property-theme.mapper";

export const mapPropertyFromDto = (propertyDto: PropertyDto): Property => ({
  id: propertyDto.id.toString(),
  theme: mapPropertyThemeFromDto(propertyDto.propertyTheme),
});
